import { supabasePublic, supabaseSchema } from '../../components/supabaseClient';

// physician_name lives on public.schema_settings (one row per schema), so this
// must go through the public client — the default client is bound to the tenant
// schema. Naming the column is safe here; the select('*') convention elsewhere
// exists only for the capitalised "Group" column, which PostgREST lowercases in
// a select list.
export async function fetchSchemaPhysician(schema = supabaseSchema) {
  try {
    const { data, error } = await supabasePublic()
      .from('schema_settings')
      .select('physician_name')
      .eq('schema_name', schema)
      .single();
    if (error) return '';
    return String(data?.physician_name || '').trim();
  } catch (_) {
    // A missing schema_settings row must not block the import.
    return '';
  }
}

// `type` is a fallback: a value present in the spreadsheet always wins.
//
// `physician_name` is NOT a fallback. An imported file is always single-schema,
// and the schema's own schema_settings row is the authority on who the physician
// is, so it overwrites unconditionally — the importer never reads a physician
// column out of the file at all.
//
// user_id is always stamped, because the schedule query filters on it and the
// notes-c timezone trigger keys off it.
export function applyScheduleDefaults(rows, { physicianName = '', defaultType = '', userId = null } = {}) {
  return rows.map((row) => {
    const out = { ...row };
    if (physicianName) out.physician_name = physicianName;
    if (defaultType && !out.type) out.type = defaultType;
    if (userId) out.user_id = userId;
    return out;
  });
}
